
import Header from '../../components/Header/Header';
import Text from '../Text/text';
import { Container } from './styles';

function HomeTerms() {
  return (
    <>
    <Header/>
    <Container>
    <Text/>
    </Container>
    </>
  );
}

export default HomeTerms;